import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setDebitConfirmAddress } from 'stash/actions';
import {
	confirmAddressCta,
	confirmAddress,
	confirmAddressScreenView,
} from 'stash/actions/debitSignUpTrackingEvents';
import ConfirmAddressScreen from './ConfirmAddressScreen';
import { useFetch } from '@stashinvest/use-fetch';
import { verifyEntirePost } from './verifyAddressFormatter';

const mapStateToProps = (state) => {
	const { address } = state.application.debitSignUp;
	const { profile } = state.entities;

	return {
		address: address || {
			addressLine1: profile.home_street_address[0],
			addressLine2: profile.home_street_address[1],
			city: profile.home_city,
			state: profile.home_state,
			postalCode: profile.home_postal_code,
		},
	};
};

const mapDispatchToProps = {
	confirmAddress,
	setDebitConfirmAddress,
	confirmAddressCta,
	confirmAddressScreenView,
};

export function DebitSignUpConfirmAddressScreen(props) {
	const verifyAddress = useFetch({});

	const {
		address,
		confirmAddress,
		confirmAddressCta,
		setDebitConfirmAddress,
		confirmAddressScreenView,
		completeStep,
	} = props;

	const handleAddressSubmit = async (values) => {
		const verify = await verifyAddress.fetch(verifyEntirePost(values));

		if (verify?.status === 200) {
			confirmAddressCta();
			confirmAddress(values);
			setDebitConfirmAddress(true);
			return completeStep();
		}
	};

	useEffect(() => {
		confirmAddressScreenView();
	}, [confirmAddressScreenView]);

	return (
		<ConfirmAddressScreen
			verifyAddress={verifyAddress}
			initialAddress={address}
			handleSubmit={handleAddressSubmit}
		/>
	);
}

DebitSignUpConfirmAddressScreen.defaultProps = {
	confirmAddress: () => {},
	setDebitConfirmAddress: () => {},
	completeStep: () => {},
};

DebitSignUpConfirmAddressScreen.propTypes = {
	address: PropTypes.object,
	confirmAddress: PropTypes.func.isRequired,
	setDebitConfirmAddress: PropTypes.func.isRequired,
	completeStep: PropTypes.func.isRequired,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DebitSignUpConfirmAddressScreen);
